import axios from 'axios'
import store from '@state/store'

//axios.defaults.baseURL = 'http://localhost:3000/hort-facil/api/v1/'
axios.defaults.baseURL = 'https://g5hd27eou5.execute-api.us-east-1.amazonaws.com/prod/hort-facil/api/v1/'


export function setAuthorization(token) {
   axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
 }

 export function unsetAuthorization() {
   delete axios.defaults.headers.common['Authorization']
 }

axios.interceptors.response.use((response) => response, (error) => {
  if(error.response.status===401){
    store.dispatch('auth/logOut');
    store.dispatch('auth/validate');
  }else
    throw error
});

export default axios
